<template>
  <div class="search-options">
    <!-- INDEXES -->
    <div class="search-options-indexes">
      <span>{{ options.indexStart }}</span> to
      <span>{{ options.indexEnd }}</span> of
      <span>{{ options.totalResults }}</span> for <span>{{ searchInput }}</span>
    </div>

    <!-- SELECTED -->
    <div class="search-options-selections">
      <!-- SORT -->
      <select v-model="selectedSort">
        <option v-bind:value="o" v-for="o in options.sorts">
          {{ o.label }}
        </option>
      </select>

      <!-- LIMIT -->
      <select v-model="selectedLimit">
        <option v-bind:value="l" v-for="l in options.limits">{{ l }}</option>
      </select>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SearchOption",
  computed: {
    ...mapState({
      searchInput: (state) => state.search.searchInput,
      options: (state) => state.search.options,
    }),
    selectedSort: {
      get() {
        return this.$store.getters.selectedSort;
      },
      set(value) {
        this.$store.commit("setSelectedSort", value);
      },
    },
    selectedLimit: {
      get() {
        return this.$store.getters.selectedLimit;
      },
      set(value) {
        this.$store.commit("setselectedLimit", value);
      },
    },
  },
  methods: {
    optionsChanged() {
      this.$emit("optionsChanged");
    },
  },
};
</script>

<style scoped>
.search-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.search-options-indexes {
  margin-bottom: 8px;
  white-space: nowrap;
  word-break: keep-all;
}

.search-options-selections {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.search-options-selections select {
  width: auto;
  margin: 0;
  margin-left: 10px;
}
.search-options-selections select:first-child {
  margin-left: 0px;
}
</style>


// WEBPACK FOOTER //
// searchOption.vue?60983ef7